export const DYDX_CHAIN = {
  name: 'dv4tnt',
  chainId: 'dydx-mainnet-1',
};
